<div #scrollContainer cdkScrollable (scroll)="onScroll(scrollContainer)" class="scroll-container">
  <div class="filtration-section" [formGroup]="filtrationForm">
    <div class="tabs-and-add-btn">
      <!-- TABS -->
      <div class="tabs">
        <div
          class="tab"
          [class.active]="selectedTab() === 'messages'"
          (click)="selectTab('messages')">
          {{ 'messageCenter.tab_messages' | translate }}
          @if (unreadMessages().length) {
            <span class="tab-count">{{ unreadMessages().length }}</span>
          }
        </div>

        <div
          class="tab"
          [class.active]="selectedTab() === 'sms'"
          (click)="selectTab('sms')">
          {{ 'messageCenter.tab_sms' | translate }}
          @if (unreadSmsMessages().length) {
            <span class="tab-count">{{ unreadSmsMessages().length }}</span>
          }
        </div>
      </div>

      @if (selectedTab() === 'messages') {
        <button
          class="app-button app-button_white new-group-btn"
          (click)="createChat()">
          <mat-icon>group_add</mat-icon>
          {{ 'messageCenter.createGroupChat' | translate }}
        </button>
      }
    </div>

    <div class="search-container">
      <mat-icon class="search-icon-prefix">search</mat-icon>
      <input
        class="form-control"
        type="text"
        appTrimInput
        formControlName="search"
        [placeholder]="'placeholders.search' | translate"/>
        
      @if (searchText) {
        <mat-icon
          class="search-icon-suffix"
          (click)="filtrationForm.controls.search.setValue('')">
          close
        </mat-icon>
      }
    </div>

    @if (searchText) {
      <app-filter-pills
        formControlName="lookup_field"
        [pills]="filterPills">
      </app-filter-pills>
    }
  </div>

  @if (!isLoadingWithReplace) {
    <div class="chats-container">
      @for (chat of items; track chat.id; let chatIndex = $index) {
        <app-chats-list-item
          [chat]="chat"
          [userId]="mcProfile.id"
          [isActive]="activeChatId() === chat.id"
          (chatSelected)="onChatClick($event)"
          (deleteChat)="deleteChat(chat)">
        </app-chats-list-item>
      }
    </div>
  }

  @if (isLoading) {
    <app-loading></app-loading>
  }

  @if (isNoItems) {
    <app-empty-state-placeholder
      icon="assets/icons/inbox.svg"
      [size]="64"
      [showCircleBg]="true"
      [text]="'messageCenter.noCoversations' | translate"
      [description]="'messageCenter.noCoversationsDescription' | translate"
      [showButton]="false">
    </app-empty-state-placeholder>
  }
</div>
